import { authLink } from "../utils/authRedirect";
import { useState, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

export default function ProtectedRoute() {
  const [user, setUser] = useState(undefined); // undefined = loading
  const location = useLocation();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (nextUser) => setUser(nextUser ?? null));
    return () => unsub();
  }, []);

  if (user === undefined) return null;
  if (!user) {
    return <Navigate to={authLink("/login", location.pathname + location.search + location.hash)} replace />;
  }
  return <Outlet />;
}
